import React from "react";
import { Box, Typography } from "@mui/material";

// Shell de dos columnas del portal de autenticacion: a la izquierda la marca
// (se oculta en movil), a la derecha el formulario del paso activo.
const AuthLayout = ({ steps, activeStep, children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexWrap: "wrap",
        bgcolor: "#0b141d",
        color: "text.primary",
      }}
    >
      <Box
        sx={{
          flex: "1 1 420px",
          minHeight: { xs: 180, md: 320 },
          background: "linear-gradient(160deg,#0e1a26 0%,#1e3d52 100%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: { xs: 2, md: 4 },
          p: { xs: 3, md: 6 },
          boxSizing: "border-box",
        }}
      >
        <Box
          component="img"
          src="/logo-abg-ebg-blanco.png"
          alt="ABG · Escuela Bancaria de Guatemala"
          sx={{
            width: { xs: 160, md: 220 },
            height: "auto",
            objectFit: "contain",
            display: "block",
          }}
        />

        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            gap: 1.75,
            maxWidth: 420,
          }}
        >
          <Typography
            component="h1"
            sx={{ fontSize: 30, fontWeight: 700, lineHeight: 1.2 }}
          >
            Banqueros educando en administración bancaria y financiera
          </Typography>
          <Typography sx={{ fontSize: 14, color: "#a9bfd1", lineHeight: 1.6 }}>
            Un solo acceso para control académico, agendas, formularios y
            eventos.
          </Typography>
        </Box>

        <Typography
          sx={{ display: { xs: "none", md: "block" }, fontSize: 12, color: "#5f7a91" }}
        >
          © {new Date().getFullYear()} Escuela Bancaria de Guatemala
        </Typography>
      </Box>

      <Box
        sx={{
          flex: "1 1 380px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 3, md: "40px 24px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          <StepDots steps={steps} activeStep={activeStep} />
          {children}
          <Typography
            sx={{ fontSize: 12, color: "#5f7a91", textAlign: "center" }}
          >
            Acceso restringido a colaboradores y asesores autorizados
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

// Indicador de pasos: los ya completados quedan en verde, el actual en azul y
// los pendientes apagados. El total varia segun el flujo (2 pasos en un login
// normal, hasta 4 en el primer ingreso).
const StepDots = ({ steps, activeStep }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
    {steps.map((label, index) => {
      const done = index < activeStep;
      const current = index === activeStep;
      return (
        <React.Fragment key={label}>
          {index > 0 && (
            <Box sx={{ flex: 1, height: "1px", bgcolor: "#23394d" }} />
          )}
          <Box
            title={label}
            sx={{
              width: 26,
              height: 26,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: 700,
              flexShrink: 0,
              bgcolor: done
                ? "rgba(76,195,138,0.12)"
                : current
                ? "#14283a"
                : "transparent",
              color: done ? "#4cc38a" : current ? "#9ed1f2" : "#5f7a91",
              border: `1px solid ${
                done ? "#4cc38a" : current ? "#4da3d8" : "#23394d"
              }`,
            }}
          >
            {index + 1}
          </Box>
        </React.Fragment>
      );
    })}
  </Box>
);

export default AuthLayout;
